import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class LoaderService {

  public loaderImageShow: boolean = false;
  public loaderMessage: string = 'Loading...';
  private loaderId!: HTMLElement
  constructor() { }

  showLoader = (message: string = 'Loading...'): void => {
    if (!this.loaderId) {
      const loader = document.getElementById('loader');
      if (loader){
        this.loaderId = loader;
      }else{
        return;
      }
    }
    this.loaderId.style.display = 'block';
    this.loaderImageShow = true;
    this.loaderMessage = message;
    setTimeout(() => { this.loaderImageShow = true; }, 10)
  }

  hideLoader = (): void => {
    if (!this.loaderId)return;
    this.loaderId.style.display = 'none';

    setTimeout(() => { this.loaderImageShow = false; }, 100)

  }


  // isLoading: boolean = false;
  // loaderMessage1: string = 'Loading...';


  // show(message: string = 'Loading...'): void {
  //   this.loaderMessage = message;
  //   this.isLoading = true;
  // }

  // hide(): void {
  //   this.isLoading = false;
  // }
}
